export default __webpack_public_path__ + "static/media/flower-1.038e5613.png";